import { useEffect } from 'react';

/**
 * Observes every element with a "reveal" or "reveal-scale" class and adds
 * "in-view" once it scrolls into the viewport, triggering the CSS
 * transition defined in App.css. Runs once on mount — the whole page tree
 * is already rendered, so all target elements exist by then.
 */
const useScrollReveal = () => {
  useEffect(() => {
    const targets = document.querySelectorAll('.reveal, .reveal-scale');
    if (!targets.length) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      targets.forEach((el) => el.classList.add('in-view'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
};

export default useScrollReveal;
